<!--
 * @Author:
 * @LastEditTime: 2022-04-18 16:28:29
 * @Description: 新增、编辑api
-->
<template>
  <el-dialog
    v-dialogDrag
    class="mini-dialog"
    :append-to-body="true"
    :visible.sync="visible"
    title="驳回"
  >
    <el-form :model="form" ref="form" label-width="150px">
      <el-form-item
        label="驳回原因"
        prop="reason"
        :rules="[
          {
            required: true,
            message: '请输入驳回原因',
            trigger: 'change',
          },
        ]"
      >
        <el-input
          class="el-input"
          placeholder="请输入驳回原因"
          type="textarea"
          rows="3"
          v-model="form.reason"
          size="small"
          clearable
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer flex justify-center items-center">
      <el-button
        :loading="loading"
        size="small"
        type="primary"
        class="iconfont icon-save"
        @click="save()"
        >保存</el-button
      >
      <el-button size="small" class="iconfont icon-close" @click="visible = false">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { SourcesDangerRiskGradeControlApi } from '@wiz-api/double-prevention-management'

const sourcesDangerRiskGradeControlApi = new SourcesDangerRiskGradeControlApi()
export default {
  name: 'reject-dialog',
  props: {
    taskId: {
      default: '',
    },
  },
  components: {},
  watch: {
    visible(val) {
      if (!val) {
        this.$emit('cancel')
      }
    },
  },
  data() {
    return {
      visible: true,
      form: {},
      formLoading: false,
    }
  },
  computed: {},
  methods: {
    async save() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (!this.taskId) return
          this.loading = true
          const [err, res] = await sourcesDangerRiskGradeControlApi.overruled({
            body: {
              sourcesDangerRecognitionPlanTaskId: this.taskId,
              ...this.form,
            },
          })
          if (!err) {
            this.loading = false
            this.$emit('handleOk')
          }
        }
      })
    },
  },
  created() {},
}
</script>

<style scoped lang="scss"></style>
